import React from 'react'
import { Navigate } from 'react-router-dom'
import { getDecryptedUserFromCookie } from './utils/getCookie';


function ProtectedRoute({ children }) {
    const isAuthenticated = getDecryptedUserFromCookie("gta_mainstateuser")||"";
     const userLoggedIn = isAuthenticated && isAuthenticated?.main_id;

    return userLoggedIn ? children : <Navigate to="/home/login" />;
}
export default ProtectedRoute;